/* eslint-disable comma-dangle */
/* eslint-disable quotes */
import React, { useEffect, useState } from 'react';
import clsx from 'clsx';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import Drawer from '@material-ui/core/Drawer';
import List from '@material-ui/core/List';
import CssBaseline from '@material-ui/core/CssBaseline';
import Divider from '@material-ui/core/Divider';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import { grey } from '@material-ui/core/colors';
import SettingIcon from '@material-ui/icons/Settings';
import InfoIcon from '@material-ui/icons/InfoOutlined';
import DashboardOutlinedIcon from '@material-ui/icons/DashboardOutlined';
import Person from '@material-ui/icons/Person';
import AssessmentOutlined from '@material-ui/icons/AssignmentIndOutlined';
import BusinessOutlinedIcon from '@material-ui/icons/BusinessOutlined';
import HomeWorkOutlinedIcon from '@material-ui/icons/HomeWorkOutlined';
import Transition from '@material-ui/icons/TransferWithinAStationOutlined';
import LocationCityIcon from '@material-ui/icons/LocationCity';
import AvTimerIcon from '@material-ui/icons/AvTimer';
import AssignmentOutlinedIcon from '@material-ui/icons/AssignmentOutlined';
import Reports from '@material-ui/icons/ListAlt';
import '../../../public/css/style.less';
import './SideNav.less';
import { NavLink, useHistory } from 'react-router-dom';
import Tooltip from '@material-ui/core/Tooltip';
import { ExpandLess, ExpandMore, MonetizationOnOutlined } from '@material-ui/icons';
import { IsBillingAccountingTabVisible, IsSectionVisible, IsComplianceAccess, IsYearEndBonusAccess } from '../../../utils/helper';
import { SECTIONS } from '../../../constants/appConstants';
import AirlineSeatReclineExtraIcon from '@material-ui/icons/AirlineSeatReclineExtra';
import HourglassFullSharpIcon from '@material-ui/icons/HourglassFullSharp';
import PrimarySearchAppBar from '../TopNav/TopNav';
import AccountBalanceWalletIcon from '@material-ui/icons/AccountBalanceWallet';
import CancelPresentationIcon from '@material-ui/icons/CancelPresentation';
import InputIcon from '@material-ui/icons/Input';
import GridOnIcon from '@material-ui/icons/GridOn';
import StorageIcon from '@material-ui/icons/Storage';
import DonutLargeIcon from '@material-ui/icons/DonutLarge';
import CancelScheduleSendIcon from '@material-ui/icons/CancelScheduleSend';
const drawerWidth = 295;

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  appBarShift: {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  menuButton: {
    marginRight: 36,
  },
  hide: {
    display: 'none',
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
    whiteSpace: 'nowrap',
  },
  drawerOpen: {
    width: drawerWidth,
    backgroundColor: '#002f6c',
    color: '#FFFFFF',
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerClose: {
    backgroundColor: '#002f6c',
    color: '#FFFFFF',
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    overflowX: 'hidden',
    width: theme.spacing(7) + 1,
    [theme.breakpoints.up('sm')]: {
      width: theme.spacing(9) + 1,
    },
  },
  toolbar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: theme.spacing(0, 1),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
  },
}));
export default function MiniDrawer(props) {
  const classes = useStyles();
  const theme = useTheme();
  const [open, setOpen] = React.useState(false);
  const [isClicked, setIsClicked] = React.useState(false);
  const [selectedMenu, setSelected] = React.useState(0);
  const [setToInitialState, setInitialState] = useState(true);
  const [setCollapsible, setCollapsibleSelected] = useState(0);
  const history = useHistory();
  const layout = '';

  const handleCollapsible = (value) => {
    setCollapsibleSelected(value);
  };

  const handleDrawerOpen = () => {
    setOpen(true);
  };
  // console.log(props);
  const handleDrawerClose = (selectedIndex) => {
    if (selectedIndex !== undefined) {
      setSelected(selectedIndex);
    }
    setInitialState(!setToInitialState);
    setOpen(false);
    setIsClicked(!isClicked);
    props.handelReload();
  };

  useEffect(() => {
    switch (history.location.pathname) {
      case '/Dashboard':
        setSelected(0);
        break;
      case '/employees':
        setSelected(1);
        break;
      case '/allocations':
        setSelected(2);
        break;
      case '/transition':
        setSelected(3);
        break;
      case '/properties':
        setSelected(4);
        break;
      case '/markets':
        setSelected(5);
        break;
      case '/Assignments':
        setSelected(6);
        break;
      case '/Reports':
        setSelected(7);
        break;
      case '/configurations':
        setSelected(8);
        break;
      case '/ReimbursementVarianceAnalysis':
        setSelected(9);
        break;
      case '/clients':
        setSelected(11);
        break;
      case '/aboutUs':
        setSelected(10);
        break;
      // case '/overtimeAttendance':
      //   setSelected(13);
      //   break;
      case '/employeeOvertimeAttendanceSheet':
        setSelected(12);
        break;
      case '/billingAccountingAdjustments':
        setSelected(14);
        break;
      case '/closePayPeriod':
        setSelected(15);
        break;
      case '/compliance':
        setSelected(16);
        break;
      case '/employeeYearlyBonus':
        setSelected(17);
        break;
      case '/yearlyBonusAccrual':
        setSelected(18);
        break;
      case '/yearEndBonusCompliance':
        setSelected(19);
        break;
      case '/closeYearEndBonus':
        setSelected(20);
        break;
      case '/propertyTenantCountMapping':
        setSelected(21);
        break;
      default:
        break;
    }
    setInitialState(!setToInitialState);
  }, [history.location.pathname]);
  return (
    <div className={classes.root}>
      <CssBaseline />
      <Drawer
        variant="permanent"
        className={clsx(classes.drawer, {
          [classes.drawerOpen]: open,
          [classes.drawerClose]: !open,
        })}
        classes={{
          paper: clsx({
            [classes.drawerOpen]: open,
            [classes.drawerClose]: !open,
          }),
        }}
      >
        <IconButton
          color="inherit"
          aria-label="open drawer"
          onClick={() => handleDrawerOpen()}
          className={clsx({
            [classes.hide]: open,
          })}
        >
          <MenuIcon className="white-button" style={{ color: grey[50] }} />
        </IconButton>
        <span>
          <IconButton
            onClick={() => handleDrawerClose()}
            className={clsx({
              [classes.hide]: !open,
            })}
          >
            {theme.direction === 'rtl'
              ? (
                <ChevronRightIcon
                  className="white-button"
                  style={{ color: grey[50] }}
                />
              )
              : (
                <ChevronLeftIcon
                  className="white-button"
                  style={{ color: grey[50] }}
                />
              )}
          </IconButton>
        </span>
        <Divider />
        <List>
          {IsSectionVisible(SECTIONS.DASHBOARD) &&
            <NavLink
              onClick={() => handleDrawerClose(0)}
              to={layout + '/Dashboard'}
            >
              <ListItem button selected={selectedMenu === 0}>
                <ListItemIcon>
                  <Tooltip title="Dashboard" placement="right">
                    <DashboardOutlinedIcon style={{ color: grey[50] }} />
                  </Tooltip>
                </ListItemIcon>

                <ListItemText primary="Dashboard" style={{ color: grey[50] }} />
              </ListItem>
            </NavLink>
          }
          {IsSectionVisible(SECTIONS.PROPERTY_TRANSITION) &&
            <NavLink
              onClick={() => handleDrawerClose(3)}
              to={{
                pathname: layout + '/transition',
                navProps: { reload: !isClicked }
              }}
            >
              {' '}
              <ListItem button selected={selectedMenu === 3}>
                <ListItemIcon>
                  <Tooltip title="Property Transitions" placement="right">
                    <Transition style={{ color: grey[50] }} />
                  </Tooltip>
                </ListItemIcon>

                <ListItemText
                  primary="Property Transitions"
                  style={{ color: grey[50] }}
                ></ListItemText>
                {/* {open ? <ExpandLess /> : <ExpandMore />} */}
              </ListItem>
            </NavLink>
          }
          {IsSectionVisible(SECTIONS.EMPLOYEES) &&
            <NavLink
              onClick={() => handleDrawerClose(1)}
              to={{
                pathname: layout + '/employees',
                navProps: { reload: !isClicked }
              }}
            >
              {' '}
              <ListItem button selected={selectedMenu === 1}>
                <ListItemIcon>
                  <Tooltip title="Employees" placement="right">
                    <Person style={{ color: grey[50] }} />
                  </Tooltip>
                </ListItemIcon>

                <ListItemText
                  primary="Employees"
                  style={{ color: grey[50] }}
                ></ListItemText>
                {/* {open ? <ExpandLess /> : <ExpandMore />} */}
              </ListItem>
            </NavLink>
          }
          {IsSectionVisible(SECTIONS.ALLOCATIONS) &&
            <NavLink
              onClick={() => handleDrawerClose(2)}
              to={{
                pathname: layout + '/allocations',
                navProps: { reload: !isClicked }
              }}
            >
              {' '}
              <ListItem button selected={selectedMenu === 2}>
                <ListItemIcon>
                  <Tooltip title="Allocations" placement="right">
                    <AssessmentOutlined style={{ color: grey[50] }} />
                  </Tooltip>
                </ListItemIcon>

                <ListItemText
                  primary="Allocations"
                  style={{ color: grey[50] }}
                ></ListItemText>
                {/* {open ? <ExpandLess /> : <ExpandMore />} */}
              </ListItem>
            </NavLink>
          }
          {IsSectionVisible(SECTIONS.CLIENTS) &&
            <NavLink
              onClick={() => handleDrawerClose(11)}
              to={{
                pathname: layout + '/clients',
                navProps: { reload: !isClicked }
              }}
            >
              {' '}
              <ListItem button selected={selectedMenu === 11}>
                <ListItemIcon>
                  <Tooltip title="Clients" placement="right">
                    <AirlineSeatReclineExtraIcon style={{ color: grey[50] }} />
                  </Tooltip>
                </ListItemIcon>

                <ListItemText
                  primary="Clients"
                  style={{ color: grey[50] }}
                ></ListItemText>
              </ListItem>
            </NavLink>
          }
          {IsSectionVisible(SECTIONS.PROPERTIES) &&
            <NavLink
              onClick={() => handleDrawerClose(4)}
              to={{
                pathname: layout + '/properties',
                navProps: { reload: !isClicked }
              }}
            >
              {' '}
              <ListItem button selected={selectedMenu === 4}>
                <ListItemIcon>
                  <Tooltip title="Properties" placement="right">
                    <BusinessOutlinedIcon style={{ color: grey[50] }} />
                  </Tooltip>
                </ListItemIcon>

                <ListItemText
                  primary="Properties"
                  style={{ color: grey[50] }}
                ></ListItemText>
                {/* {open ? <ExpandLess /> : <ExpandMore />} */}
              </ListItem>
            </NavLink>
          }
          {IsSectionVisible(SECTIONS.CENTERALIZED_AR_PROPERTY_TENANT_MAPPING) &&
            <NavLink
              onClick={() => handleDrawerClose(21)}
              to={{
                pathname: layout + '/propertyTenantCountMapping',
                navProps: { reload: !isClicked }
              }}
            >
              {' '}
              <ListItem button selected={selectedMenu === 21}>
                <ListItemIcon>
                  <Tooltip title="Property Tenant Mapping" placement="right">
                    <HomeWorkOutlinedIcon style={{ color: grey[50] }} />
                  </Tooltip>
                </ListItemIcon>

                <ListItemText
                  primary="Property Tenant Mapping"
                  style={{ color: grey[50] }}
                ></ListItemText>
                {/* {open ? <ExpandLess /> : <ExpandMore />} */}
              </ListItem>
            </NavLink>
          }
          {IsSectionVisible(SECTIONS.MARKETS) &&
            <NavLink
              onClick={() => handleDrawerClose(5)}
              to={{
                pathname: layout + '/markets',
                navProps: { reload: !isClicked }
              }}
            >
              {' '}
              <ListItem button selected={selectedMenu === 5}>
                <ListItemIcon>
                  <Tooltip title="Markets" placement="right">
                    <LocationCityIcon style={{ color: grey[50] }} />

                  </Tooltip>
                </ListItemIcon>

                <ListItemText
                  primary="Markets"
                  style={{ color: grey[50] }}
                ></ListItemText>
                {/* {open ? <ExpandLess /> : <ExpandMore />} */}
              </ListItem>
            </NavLink>
          }
          {IsSectionVisible(SECTIONS.ASSIGNMENTS) &&
            <NavLink
              onClick={() => handleDrawerClose(6)}
              to={{
                pathname: layout + '/Assignments',
                navProps: { reload: !isClicked }
              }}
            >
              {' '}
              <ListItem button selected={selectedMenu === 6}>
                <ListItemIcon>
                  <Tooltip title="Assignments" placement="right">
                    <AssignmentOutlinedIcon style={{ color: grey[50] }} />
                  </Tooltip>
                </ListItemIcon>

                <ListItemText
                  primary="Assignments"
                  style={{ color: grey[50] }}
                ></ListItemText>
                {/* {open ? <ExpandLess /> : <ExpandMore />} */}
              </ListItem>
            </NavLink>
          }
          {IsSectionVisible(SECTIONS.REPORTS) &&
            <NavLink
              onClick={() => handleDrawerClose(7)}
              to={{
                pathname: layout + '/Reports',
                navProps: { reload: !isClicked }
              }}
            >
              {' '}
              <ListItem button selected={selectedMenu === 7}>
                <ListItemIcon>
                  <Tooltip title="Reports" placement="right">
                    <Reports style={{ color: grey[50] }} />
                  </Tooltip>
                </ListItemIcon>

                <ListItemText
                  primary="Reports"
                  style={{ color: grey[50] }}
                ></ListItemText>
                {/* {open ? <ExpandLess /> : <ExpandMore />} */}
              </ListItem>
            </NavLink>
          }
          {(IsSectionVisible(SECTIONS.OVERTIMEATTANDENCESHEET) ||
            IsBillingAccountingTabVisible() ||
            IsSectionVisible(SECTIONS.ALLOCATION_COMPLIANCE)
          ) &&
            <Divider className='white-Divider' />}
          {IsSectionVisible(SECTIONS.OVERTIMEATTANDENCESHEET) &&
            <NavLink
              onClick={() => handleDrawerClose(12)}
              to={layout + '/employeeOvertimeAttendanceSheet'}
            >
              {' '}
              <ListItem button selected={selectedMenu === 12}>
                <ListItemIcon>
                  <Tooltip title="Overtime Attendance" placement="right">
                    <AvTimerIcon style={{ color: grey[50] }} />
                  </Tooltip>
                </ListItemIcon>

                <ListItemText
                  primary="Overtime Attendance"
                  style={{ color: grey[50] }}
                ></ListItemText>
              </ListItem>
            </NavLink>
          }
          {IsBillingAccountingTabVisible() && <NavLink
            onClick={() => handleDrawerClose(14)}
            to={{
              pathname: layout + '/billingAccountingAdjustments',
              navProps: { reload: !isClicked }
            }}
          >
            {' '}
            <ListItem button selected={selectedMenu === 14}>
              <ListItemIcon>
                <Tooltip title="Billing/Accounting Adjustments" placement="right">
                  <AccountBalanceWalletIcon style={{ color: grey[50] }} />
                </Tooltip>
              </ListItemIcon>

              <ListItemText
                primary="Billing/Accounting"
                style={{ color: grey[50] }}
              ></ListItemText>
            </ListItem>
          </NavLink>}
          {IsBillingAccountingTabVisible() && <NavLink
            onClick={() => handleDrawerClose(15)}
            to={{
              pathname: layout + '/closePayPeriod',
              navProps: { reload: !isClicked }
            }}
          >
            {' '}
            <ListItem button selected={selectedMenu === 15}>
              <ListItemIcon>
                <Tooltip title="Close Pay Period" placement="right">
                  <CancelPresentationIcon style={{ color: grey[50] }} />
                </Tooltip>
              </ListItemIcon>

              <ListItemText
                primary="Close Pay Period"
                style={{ color: grey[50] }}
              ></ListItemText>
            </ListItem>
          </NavLink>}
          {IsSectionVisible(SECTIONS.ALLOCATION_COMPLIANCE) &&
            <NavLink
              onClick={() => handleDrawerClose(16)}
              to={{
                pathname: layout + '/compliance',
                navProps: { reload: !isClicked }
              }}
            >
              {' '}
              <ListItem button selected={selectedMenu === 16}>
                <ListItemIcon>
                  <Tooltip title="Compliance" placement="right">
                    <InputIcon style={{ color: grey[50] }} />
                  </Tooltip>
                </ListItemIcon>

                <ListItemText
                  primary="Compliance"
                  style={{ color: grey[50] }}
                ></ListItemText>
              </ListItem>
            </NavLink>}
          {(IsBillingAccountingTabVisible() || IsYearEndBonusAccess() || IsSectionVisible(SECTIONS.YEAR_END_COMPLIANCE)) &&
            <Divider className='white-Divider' />}
          {IsYearEndBonusAccess() && <NavLink
            onClick={() => handleDrawerClose(17)}
            to={{
              pathname: layout + '/employeeYearlyBonus',
              navProps: { reload: !isClicked }
            }}
          >
            {' '}
            <ListItem button selected={selectedMenu === 17}>
              <ListItemIcon>
                <Tooltip title="Employee Yearly Bonus" placement="right">
                  <GridOnIcon style={{ color: grey[50] }} />
                </Tooltip>
              </ListItemIcon>

              <ListItemText
                primary="Employee Yearly Bonus"
                style={{ color: grey[50] }}
              ></ListItemText>
            </ListItem>
          </NavLink>}
          {IsYearEndBonusAccess() && <NavLink
            onClick={() => handleDrawerClose(18)}
            to={{
              pathname: layout + '/yearlyBonusAccrual',
              navProps: { reload: !isClicked }
            }}
          >
            {' '}
            <ListItem button selected={selectedMenu === 18}>
              <ListItemIcon>
                <Tooltip title="Yearly Bonus Accrual" placement="right">
                  <StorageIcon style={{ color: grey[50] }} />
                </Tooltip>
              </ListItemIcon>

              <ListItemText
                primary="Yearly Bonus Accrual"
                style={{ color: grey[50] }}
              ></ListItemText>
            </ListItem>
          </NavLink>}
          {IsSectionVisible(SECTIONS.YEAR_END_COMPLIANCE) &&
            <NavLink
              onClick={() => handleDrawerClose(19)}
              to={{
                pathname: layout + '/yearEndBonusCompliance',
                navProps: { reload: !isClicked }
              }}
            >
              {' '}
              <ListItem button selected={selectedMenu === 19}>
                <ListItemIcon>
                  <Tooltip title="Year End Bonus Compliance" placement="right">
                    <DonutLargeIcon style={{ color: grey[50] }} />
                  </Tooltip>
                </ListItemIcon>

                <ListItemText
                  primary="Year End Bonus Compliance"
                  style={{ color: grey[50] }}
                ></ListItemText>
              </ListItem>
            </NavLink>}
          {IsBillingAccountingTabVisible() && <NavLink
            onClick={() => handleDrawerClose(20)}
            to={{
              pathname: layout + '/closeYearEndBonus',
              navProps: { reload: !isClicked }
            }}
          >
            {' '}
            <ListItem button selected={selectedMenu === 20}>
              <ListItemIcon>
                <Tooltip title="Close Year End Bonus Period" placement="right">
                  <CancelScheduleSendIcon style={{ color: grey[50] }} />
                </Tooltip>
              </ListItemIcon>

              <ListItemText
                primary="Close Year End Bonus Period"
                style={{ color: grey[50] }}
              ></ListItemText>
            </ListItem>
          </NavLink>}
          {(IsSectionVisible(SECTIONS.CONFIGURATION) || IsSectionVisible(SECTIONS.DATA_CENTER_CONFIGURATION)) &&
            <Divider className='white-Divider' />
          }
          {(IsSectionVisible(SECTIONS.CONFIGURATION) || IsSectionVisible(SECTIONS.DATA_CENTER_CONFIGURATION)) &&
            <NavLink
              onClick={() => handleDrawerClose(8)}
              to={{
                pathname: layout + '/configurations',
                navProps: { reload: !isClicked }
              }}
            >
              {' '}
              <ListItem button selected={selectedMenu === 8}>
                <ListItemIcon>
                  <Tooltip title="Configuration Settings" placement="right">
                    <SettingIcon style={{ color: grey[50] }} />
                  </Tooltip>
                </ListItemIcon>

                <ListItemText
                  primary="Configuration"
                  style={{ color: grey[50] }}
                ></ListItemText>
                {/* {open ? <ExpandLess /> : <ExpandMore />} */}
              </ListItem>
            </NavLink>
          }
          {IsSectionVisible(SECTIONS.ABOUT_US) &&
            <NavLink
              onClick={() => handleDrawerClose(10)}
              to={layout + '/aboutUs'}
            >
              {' '}
              <ListItem button selected={selectedMenu === 10}>
                <ListItemIcon>
                  <Tooltip title="About Us" placement="right">
                    <InfoIcon style={{ color: grey[50] }} />
                  </Tooltip>
                </ListItemIcon>

                <ListItemText
                  primary="About Us"
                  style={{ color: grey[50] }}
                ></ListItemText>
                {/* {open ? <ExpandLess /> : <ExpandMore />} */}
              </ListItem>
            </NavLink>
          }

        </List>
      </Drawer>
    </div>
  );
}
